const assets = {
  urls: {
    logos: {
      desktop: '/assets/logos/logo-bte.png',
      mobile: '/assets/logos/bouygues-telecom-mobile.svg',
      filtres: '/assets/logos/filtres.svg',
    },
  },
};

const emptyGuid = '00000000-0000-0000-0000-000000000000';

const imageDimensionForCreationForm: React.CSSProperties = {
  display: 'block',
  margin: 'auto',
  objectFit: 'contain',
  maxWidth: '500px',
  minWidth: '350px',
  maxHeight: '500px',
  minHeight: '350px',
};

enum KeyCodeEvent {
  OnEnterPressed = 13,
}

const unitCO2eq = ['mgCO', 'gCO', 'kgCO', 'TCO'];

const unitData = ['Ko', 'Mo', 'Go', 'To', 'Po'];

enum DecimalTransform {
  Default = 1,
  Export = 2,
}

const GLOBAL_CONSO_ID = 'Tous les SIRENS';

const EcoAstucesName = 'eco-astuces';
const ActualitesName = 'actualites';
const PartenairesName = 'partenaires';

export {
  ActualitesName,
  assets,
  DecimalTransform,
  EcoAstucesName,
  emptyGuid,
  GLOBAL_CONSO_ID,
  imageDimensionForCreationForm,
  KeyCodeEvent,
  PartenairesName,
  unitCO2eq,
  unitData,
};
